import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProtein = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 100 100",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Artboard",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9,50 C15.8333333,39.3333333 22.6666667,34 29.5,34 C36.3333333,34 43.1666667,39.3333333 50,50 C56.8333333,60.6666667 63.6666667,66 70.5,66 C77.3333333,66 84.1666667,60.6666667 91,50",
				id: "Line",
				stroke: "#3ca3ca",
				strokeWidth: 2,
				strokeLinecap: "square"
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "circle1",
				fill: "#3ca3ca",
				cx: 9,
				cy: 50,
				r: 6
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "circle2",
				fill: "#3ca3ca",
				cx: 30,
				cy: 34,
				r: 6
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "circle3",
				fill: "#3ca3ca",
				cx: 50,
				cy: 50,
				r: 6
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "circle4",
				fill: "#3ca3ca",
				cx: 70,
				cy: 66,
				r: 6
			}),
			/* @__PURE__ */ _jsx("circle", {
				id: "circle5",
				fill: "#3ca3ca",
				cx: 91,
				cy: 50,
				r: 6
			})
		]
	})
});
export default SvgProtein;
